import { render } from "./indexeightbanner.vue?vue&type=template&id=7ea112b8"
import script from "./indexeightbanner.vue?vue&type=script&lang=js"
export * from "./indexeightbanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__